<app-state-definition-toolbar (addNew)="openAddPanel()" />

<app-state-definition-list
  [reloadVersion]="reloadVersion"
  (edit)="openEditPanel($event)"
  (deleted)="onDeleted()" />

<app-state-definition-form-panel
  [visible]="showFormPanel"
  [statusId]="selectedStatusId"
  (visibleChange)="onFormVisibilityChange($event)"
  (saved)="onSaved()" />
